import { createAction, props } from '@ngrx/store';
import { ErrorResponse } from 'src/app/models/error/error-response.model';

export const changeErrorResponse = createAction(
  '[ApiError] Change errorResponse',
  props<{ errorResponse: ErrorResponse | undefined }>()
);
